// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__tBB_f","title":"Info_title__3vhEA","links":"Info_links__3r2PC","link":"Info_link__1ZX2H","logo":"Info_logo__3NxoT"};